import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}

// Bootstrap the application first
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    // Initialize PWA elements after bootstrap
    defineCustomElements(window);
  })
  .catch(err => console.error('Error bootstrapping app:', err));


